import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('manage');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Location } from '@angular/common';

@Component({
    selector: 'wiz-manage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/manage/view.scss */
/* src/app/manage/view.scss: no such file or directory */`],
})
export class ManageComponent implements OnInit {
    @Input() title: any;

    constructor(@Inject( Service)         public service: Service,@Inject( Location    )         private location: Location    ) {
        this.id = WizRoute.segment.id;
    }

    public list: any = [];
    public selectedItems: any[] = [];
    public target_book: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public bookEvent: any = {
        close: async () => {
            this.target_book = null;
            await this.service.render();
        }
    }

    public async clickBook(book) {
        this.target_book = null;
        await this.service.render();
        this.target_book = book.id;
        await this.service.render();
    }

    public async newBook() {
        this.target_book = "new";
        await this.service.render();
    }

    public search: any = {
        order: "title",
        text: "",
        page: 1,
        dump: 10
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public searchAction() {
        this.pagination.current = 1;
        this.load();
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("load", this.search);

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public async deleteSelectedItems() {
        let res = await this.service.alert.show({
            title: "삭제 확인",
            message: `${this.selectedItems.length}개의 항목을 삭제하시겠습니까?`,
            action: "삭제",
            cancel: "취소",
            actionBtn: "error",
            status: "error",
        });
        if (!res) return;
        for (const item of this.selectedItems) {
            const { code } = await wiz.call("remove", item);
            if (code !== 200) {
                this.service.alert.error(`항목 삭제 실패: ${item.title}`);
            }
        }
        this.selectedItems = [];
        await this.load(this.pagination.current);
    }

    public toggleAll(checked: boolean) {
        this.selectedItems = [];
        for (const item of this.list) {
            item.selected = checked;
            if (checked) {
                this.selectedItems.push(item);
            }
        }
    }

    public updateSelectedItems(item: any) {
        if (item.selected) {
            this.selectedItems.push(item);
        } else {
            this.selectedItems = this.selectedItems.filter((i) => i !== item);
        }

        this.service.render();
    }
}

export default ManageComponent;